<template>
      <v-layout row>
          <v-flex md12>
            <v-layout>
                <v-flex md12>
                    <ManifestHeader />
                </v-flex>
            </v-layout>

            <v-layout>
                <v-flex md12>
                    <ManifestBrowser />
                </v-flex>
            </v-layout>
          </v-flex>
      </v-layout>
      
</template>

<script>
import ManifestHeader from './ManifestHeader';
import ManifestBrowser from './ManifestBrowser'

export default {
components: {
    ManifestHeader, ManifestBrowser
  },

}
</script>

<style>

</style>